import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanelItem from './PanelItem';
import { useMyPanels } from '../hooks/use-panels';

const PanelsList = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useMyPanels();
  const panels = data || []; // interceptor already unwrapped to array

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-text-black">Your Panels</h3>
      </div>
      {isLoading ? (
        <div className="py-2 text-xs text-gray-400">Loading...</div>
      ) : panels.length === 0 ? (
        <p className="text-xs text-gray-400 py-2">No panels joined yet.</p>
      ) : (
        <div className="space-y-1">
          {panels.map((panel) => (
            <div key={panel.id} onClick={() => navigate(`/panels/${panel.id}`)}>
              <PanelItem
                name={panel.name}
                memberCount={panel._count?.members || 0}
                badgeCount={panel._count?.discussions || 0}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PanelsList;